<script setup>
import { ref, onMounted, onUnmounted } from 'vue';


import certificationImage from '@/assets/certification.webp';

const imageSrc = ref(certificationImage);
const isModalOpen = ref(false);

const openModal = () => (isModalOpen.value = true);
const closeModal = () => (isModalOpen.value = false);

const handleKeydown = (e) => {
  if (e.key === 'Escape' && isModalOpen.value) {
    closeModal();
  }
};

onMounted(() => window.addEventListener('keydown', handleKeydown));
onUnmounted(() => window.removeEventListener('keydown', handleKeydown));
</script>

<template>
  <section class="section-container">
    <h2 class="section-title">{{ $t('home-page.partners.title') }}</h2>
    <p class="section-subtitle">{{ $t('home-page.partners.sub-text') }}</p>
    <div class="cta-container">
      <button @click="openModal" class="btn-show-certificate">
        {{ $t('Show Certificate') }}
      </button>
    </div>
    <div class="certification-wrapper" data-aos="zoom-in-up">
      <!-- <img
        :src="imageSrc"
        alt="CDP Group Certification"
        class="certification-image"
      /> -->
    </div>

    <Transition name="modal-fade">
      <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
        <div class="modal-content" @click.stop>
          <img :src="imageSrc" alt="CDP Group Certification" class="modal-image" />
          <button @click="closeModal" class="modal-close-btn" aria-label="Close image viewer">
            &times;
          </button>
        </div>
      </div>
    </Transition>
  </section>
</template>

<style scoped>
.section-container {
  background-color: #f8f9fa;
}
.certification-wrapper {
  max-width: 1000px; /* Increased max-width */
  margin: 0 auto;
  text-align: center;
}
.certification-image {
  max-width: 80%;
  height: auto; /* Let height be automatic */
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.cta-container {
  text-align: center;
  margin-bottom: 2.5rem;
}

.btn-show-certificate {
  background-color: #0A2D61;
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  text-transform: uppercase;
}

.btn-show-certificate:hover {
  background-color: #1c4b8d;
  transform: translateY(-2px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  padding: 20px;
  box-sizing: border-box;
}

.modal-image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
}

.modal-close-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 35px;
  height: 35px;
  background: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  line-height: 35px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .certification-image {
    max-width: 100%;
  }
}
</style>